// @flow
import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

export const NotificationIcon = styled.button`
  position: relative;
  background-color: transparent;
  outline: none;
  ${({ on }) =>
    on &&
    css`
      &::before {
        content: "";
        position: absolute;
        top: -1px;
        left: -1px;
        width: 6px;
        height: 6px;
        background-color: ${buildColor("red", "500")};
        border: 1px solid ${buildColor("white", "100")};
        border-radius: 50%;
      }
    `};
`;

export const NotificationMessage = styled.div`
  position: fixed;
  bottom: ${({ isBettingModalOpen }) =>
    isBettingModalOpen ? "calc(50px + 60px)" : "60px"};
  bottom: ${({ isBettingModalOpen }) =>
    isBettingModalOpen
      ? "calc(50px + constant(safe-area-inset-bottom) + 60px)"
      : "calc(constant(safe-area-inset-bottom) + 60px)"};
  bottom: ${({ isBettingModalOpen }) =>
    isBettingModalOpen
      ? "calc(50px + env(safe-area-inset-bottom) + 60px)"
      : "calc(env(safe-area-inset-bottom) + 60px)"};
  left: 16px;
  width: calc(100% - 32px);
  border: 1px solid ${buildColor("grey", "800")};
  background-color: ${buildColor("grey", "000")};
  color: ${buildColor("grey", "800")};
  padding: 12px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  z-index: 10;

  & > svg {
    border: 1px solid ${buildColor("grey", "800")};
    fill: ${buildColor("grey", "800")};
    border-radius: 50%;
    margin-right: 12px;
  }

  &.success {
    border: 1px solid ${buildColor("green", "800")};
    background-color: ${buildColor("green", "000")};
    color: ${buildColor("green", "800")};
  }

  &.success > svg {
    border: 1px solid ${buildColor("green", "800")};
    fill: ${buildColor("green", "800")};
  }

  &.error {
    border: 1px solid ${buildColor("red", "800")};
    background-color: ${buildColor("red", "000")};
    color: ${buildColor("red", "800")};
  }

  &.error > svg {
    border: 1px solid ${buildColor("red", "800")};
    fill: ${buildColor("red", "800")};
  }
`;
